// Ported from beleef-services-frontend components/ui/Toggle.js
const Toggle = ({ checked, onChange, disabled = false }) => (
  <button
    type="button"
    onClick={() => !disabled && onChange?.(!checked)}
    disabled={disabled}
    className={`relative w-9 h-5 rounded-full transition-colors flex-shrink-0 ${
      disabled
        ? "bg-mediumgray opacity-50 cursor-not-allowed"
        : checked
          ? "bg-green-500 cursor-pointer"
          : "bg-mediumgray cursor-pointer"
    }`}
  >
    <span
      className={`absolute top-[2px] left-[2px] w-4 h-4 bg-white rounded-full shadow transition-transform ${
        checked ? "translate-x-4" : "translate-x-0"
      }`}
    />
  </button>
);

export default Toggle;
